import VoucherActiveModal from "./voucher-active-modal.component";

export default VoucherActiveModal;
